import React from 'react'

const PendingApproval = () => {
  return (
    <div className="dashboard-body">
        <h1>COURSES</h1>
        <p>Your application to be an approved instructor is pending. Please come back later to see if you have been approved.</p>
    </div>
  )
}

export default PendingApproval